// react
import React, { useState, useEffect, useRef } from 'react';

import { Box, Table, TableRow, TableBody, TableCell, Grid } from '@mui/material';
import WarehouseSharpIcon from '@mui/icons-material/WarehouseSharp';
// openlayers
import { Style, Circle, Stroke, Fill, Text, Icon } from 'ol/style'
import Map from 'ol/Map'
import View from 'ol/View'
import Overlay from 'ol/Overlay'
import Feature from 'ol/Feature'
import TopoJSON from 'ol/format/TopoJSON';
import GeoJSON from 'ol/format/GeoJSON';
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import XYZ from 'ol/source/XYZ'
import { Point } from 'ol/geom'
import OSM from 'ol/source/OSM'
import { transform, fromLonLat } from 'ol/proj'
import { toStringXY } from 'ol/coordinate';
import { getRequest } from 'utils/apiRequest';
import { useGeographic } from 'ol/proj';
import '../../assets/third-party/open-layers-controls.css';
import { useParams } from 'react-router';
import config from 'config';

// useGeographic();
const getMarkerStyle = (fillColor = '#e6f7ff', strokeColor = '#1890ff') => {
  return new Style({
    image: new Circle({
      radius: 5,
      stroke: new Stroke({
        color: strokeColor
      }),
      fill: new Fill({
        color: fillColor // attribute colour
      })
    }),
    // text: new Text({
    //   text: locData.text, // attribute code
    //   fill: new Fill({
    //     color: textColor // black text // TODO: Unless circle is dark, then white..
    //   })
    // })
  });
}
function MapRecentZipCodes(props) {

  const { zip } = useParams();
  // set intial state
  const [map, setMap] = useState()
  const [featuresLayer, setFeaturesLayer] = useState()
  const [getInfo, setGeoInfo] = useState({ })
  const [locations, setLocations] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [mapView, setMapView] = useState({zoom: 5, center: [-98.5795, 39.8283]});
  // pull refs
  const mapElement = useRef()

  // create state ref that can be accessed in OpenLayers onclick callback function
  //  https://stackoverflow.com/a/60643670
  const mapRef = useRef()
  mapRef.current = map;

  // initialize map on first render - logic formerly put into componentDidMount
  useEffect(() => {

    getRequest('/account/warehouses').then(w => {
      setWarehouses(w);
      if(zip){
        getRequest('/zip_code/'+zip).then(d => {
          setGeoInfo({ info: d, coords: [d.latitude, d.longitude] });
          setMapView({zoom: 10, center: [d.longitude, d.latitude]})
        })
      }

      getRequest('/client/recent/zips').then(d => {
        const coords = [];
        d.forEach((z) => {
          coords.push({ info: z, coords: [z.latitude, z.longitude] });
        })
        setLocations(coords);
      })
      const initMap = new Map({
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
          // initalFeaturesLayer,
        ],
        target: mapElement.current,
        view: new View({
          center: transform(mapView.center, 'EPSG:4326', 'EPSG:3857'),
          zoom: mapView.zoom,
        }),
      });
      setMap(initMap)
    });
  }, []);
  useEffect(() => {
    if (map === undefined) {
      return;
    }
    map.getView().animate({zoom: mapView.zoom, center: fromLonLat(mapView.center)});

  }, [mapView])



  React.useEffect(() => {
    if (map === undefined) {
      return;
    }

    // markers
    const features = [];
    let lastClickedFeature = null;
    locations.map((locData, i) => {
      const style = getMarkerStyle();
      const marker = new Feature({
        geometry: new Point(fromLonLat([locData.coords[1], locData.coords[0]]))
      })
      marker.setStyle(style);
      features.push(marker);
    });
    var layer = new VectorLayer({
      source: new VectorSource({
        features: features
      })
    });
    map.addLayer(layer);

    // warehouse markers
    const whFeatures = [];
    warehouses.map((wData, i) => {
      const style = new Style({
        image: new Icon({
          opacity: 1,
          src: config.baseUrl + '/warehouse.png',
          scale: 0.0113
        })
      });
      const marker = new Feature({
        geometry: new Point(fromLonLat([wData.address.longitude, wData.address.latitude]))
      })
      marker.setStyle(style);
      whFeatures.push(marker);
    });
    var layer = new VectorLayer({
      source: new VectorSource({
        features: whFeatures
      })
    });
    map.addLayer(layer);

    function formatCoordinate(coordinate) {
      const info = locations.filter((l) => {
        const locLat = parseFloat(l.coords[1]).toFixed(4);
        const locLng = parseFloat(l.coords[0]).toFixed(4);

        const coordLat = coordinate[0].toFixed(4);
        const coordLng = coordinate[1].toFixed(4);

        return locLat === coordLat && locLng === coordLng;
      });
      
      const i = {
        lat: coordinate[0].toFixed(4),
        lng: coordinate[1].toFixed(4),
        info: info[0].info
      };
      setGeoInfo(i)
    }

    // map.on('moveend', function () {
    //   const view = map.getView();
    //   const center = view.getCenter();
    //   formatCoordinate(center);
    // });

    map.on('click', function (event) {
      if(lastClickedFeature !== null){
        const style2 = getMarkerStyle();
        lastClickedFeature.setStyle(style2);
        lastClickedFeature = null;
      }
      const feature = map.getFeaturesAtPixel(event.pixel)[0];
      if (!feature) {
        setGeoInfo({});
        return;
      }
      const coordinate = feature.getGeometry().getCoordinates();
      formatCoordinate(transform(coordinate, 'EPSG:3857', 'EPSG:4326'));
      map.getView().setCenter(coordinate);
      map.getView().setZoom(8);
      const style3 = getMarkerStyle('#b2b2f0', '#7878e1');
      feature.setStyle(style3);
      lastClickedFeature = feature;
    });

    map.on('pointermove', function (event) {
      const type = map.hasFeatureAtPixel(event.pixel) ? 'pointer' : 'inherit';
      map.getViewport().style.cursor = type;
    });
  }, [locations])




const hasInfo = getInfo && getInfo.info && getInfo.info.zip_code !== undefined;

  // render component
  return (<Grid container spacing={3}>
    <Grid item xs={12} sm={!hasInfo ? 12 : 8} lg={!hasInfo ? 12 : 9.5}>
      <Box ref={mapElement} className="map-container" sx={{
        height: 'calc(100vh - 60px)',
        width: '100%',
        marginBottom: '10px'
      }}>
      </Box>
    </Grid>
    {hasInfo && (
    <Grid item xs={12} sm={4} lg={2.5} sx={{
      borderLeft: '1px solid #ccc',
      boxShadow: '-4px -5px 5px #ccc',
      zIndex: 1
      }}>
      <Box id="info-panel">
        <Table>
          <TableBody>
            {/* <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Latitude:</TableCell>
              <TableCell>{getInfo.lat}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Longitude:</TableCell>
              <TableCell>{getInfo.lng}</TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Zip:</TableCell>
              <TableCell>{getInfo.info.zip_code}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>City:</TableCell>
              <TableCell>{getInfo.info.city}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>State:</TableCell>
              <TableCell>{getInfo.info.state}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Country:</TableCell>
              <TableCell>{getInfo.info.country_code}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Unique Users</TableCell>
              <TableCell>{getInfo.info.num_unique_users}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Grid>)}
  </Grid>
  )

}

export default MapRecentZipCodes;